import React from 'react';
import { ResponsiveType } from '../../../components/molecules/Image';
import { ValidSelectedImage } from '../../FileUpload/utils/validateImage';
import { Image as ImageType, ImageState, ImageTypes } from '../../../types/api/ImageType';
import { ImagePreview } from './ImagePreview';

type PreviewProps = {
  selectedPreview: ValidSelectedImage | undefined;
  responsiveType?: ResponsiveType;
  filename?: string;
  customAltText?: string;
  imageType?: ImageTypes;
};

export function SelectedImagePreview({
  selectedPreview,
  responsiveType,
  filename,
  customAltText,
  imageType,
}: PreviewProps) {
  const image =
    selectedPreview &&
    ({
      imageType,
      src: selectedPreview.image.src,
      imageState: ImageState.ready,
    } as unknown as ImageType);

  return selectedPreview
    ? (
        <ImagePreview
          responsiveType={responsiveType}
          image={image}
          customAltText={customAltText}
          previewFilename={filename}
        />
      )
    : null;
}
